/**
 * Canvas helpers. All engine canvases are created with `willReadFrequently`, which keeps them on
 * Chromium's CPU rasteriser in both the editor and the headless render worker. GPU rasterisation
 * anti-aliases differently, so this is what makes preview and render pixel-identical.
 */

export type Ctx2D = OffscreenCanvasRenderingContext2D;

export function makeCanvas(w: number, h: number): { canvas: OffscreenCanvas; ctx: Ctx2D } {
  const canvas = new OffscreenCanvas(Math.max(1, Math.ceil(w)), Math.max(1, Math.ceil(h)));
  const ctx = canvas.getContext("2d", { willReadFrequently: true }) as Ctx2D | null;
  if (!ctx) throw new Error("2D canvas unavailable");
  return { canvas, ctx };
}
